import authenticationService from '../../../../../services/authentication/AuthenticationService';
import {getUserCount, getClientCount, getProjectCount, getSubcontractorKPI} from './dataGetters';

export default params => {
  async function getCount(dispatch, key, method) {
    try {
      const count = await method(params);
      dispatch({type: 'UPDATE_COUNT', key, count});
    } catch {
      dispatch({type: 'ERROR', key});
    }
  }

  const roles = authenticationService.roles();
  const isExplorer = roles.isExplorer();
  const isDepositor = params.organisation.depositor;

  return {
    FETCH_DATA: ({dispatch}) => async () => {
      dispatch({type: 'START_LOADING_ALL'});

      if (isDepositor && !isExplorer) {
        getCount(dispatch, 'clients', getClientCount);
      }

      getCount(dispatch, 'users', getUserCount);
      getCount(dispatch, 'projects', getProjectCount);
      getCount(dispatch, 'subcontractors', getSubcontractorKPI);
    },
    FETCH_USERS: ({dispatch}) => async () => {
      dispatch({type: 'START_LOADING', keys: ['users']});
      getCount(dispatch, 'users', getUserCount);
    },
    FETCH_SUBCONTRACTORS: ({dispatch}) => async () => {
      dispatch({type: 'START_LOADING', keys: ['subcontractors']});
      getCount(dispatch, 'subcontractors', getSubcontractorKPI);
    }
  };
};
